import React, { useState } from 'react';
import CloseIcon from '@/assets/close.svg';
import { IBasket, IBasketCms } from '@/types/simo/basket';
import { addKr } from '@/utils/helper';
import Modal from '@/generic-components/Modal';
import MinimumPriceModal from '@/generic-components/minimumPriceModal';
import ConfirmMainSubscriptionModal from './confirmDeleteSubscriptionModal';
import { useModal } from '@/generic-components/Modal/useModal';
import { IPrice } from '@/types/simo/products';
import './_filledBasket.scss';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { bodyTextRenderOptions } from '@/contentful/helper';
import { useHistory } from 'react-router-dom';
import * as urls from '@/api/urls';
import classNames from 'classnames';
import { codeToName } from '@/utils/urlMapUtility';
import Button from '@/modules/Button';

//Temp btl mapping
const btlProducts = [
  'SP01_758_69_MOBIL',
  'SP01_758_56_MOBIL',
  'SP01_758_52_MOBIL',
  'SP01_758_70_MOBIL',
  'SP01_758_71_MOBIL'
];

interface IProps {
  noOfSubscription: number;
  productCode?: string;
  basketCms: IBasketCms;
  basket: IBasket | any;
  removeSubscriptions?: (id: string) => void;
  onCancelDelete?: () => void;
  isVisible?: boolean | any;
  setIsVisible?: (value: boolean) => void | any;
  isOverviewStep: boolean;
}

const FilledBasket = (props: IProps) => {
  const {
    noOfSubscription,
    basketCms,
    basket,
    removeSubscriptions,
    onCancelDelete,
    setIsVisible,
    isVisible,
    productCode,
    isOverviewStep
  } = props;

  const {
    recurring,
    recurringTotal,
    fees,
    feesTotal,
    minimumPriceCalculation,
    linkToMinimumPriceCalculationText
  } = basket.priceSummaries[0];

  const { isShown, toggle } = useModal();
  const history = useHistory();
  const [productId, setProductId] = useState<string>();
  const [subscriptionType, setSubscriptionType] = useState<string>();

  const confirmDeleteModal = (productId: string, subscriptionType: string) => {
    setIsVisible && setIsVisible(!isVisible);
    setProductId(productId);
    setSubscriptionType(subscriptionType);
  };

  const goToNemIDOrCheckout = () => {
    const isConfigurationComplete = recurring?.every((entry: any) => {
      return entry.configuration?.isComplete;
    });
    if (isConfigurationComplete) {
      const checkoutUrl = urls.checkout.url();
      history.push(checkoutUrl);
    } else if (!basket.mustBeCprValidated) {
      const configurationUrl = urls.configuration.url({});
      history.push(configurationUrl);
    } else {
      const cprUrl = urls.mitID.url({
        state: {
          productCode,
          noOfSubscription
        }
      });
      history.push(cprUrl);
    }
  };

  const editConfiguration = () => {
    const configUrl = urls.configuration.url({
      state: {
        productCode,
        noOfSubscription
      }
    });
    history.push(configUrl);
  };

  const goToSubscription = (basisSubscriptionProductCode: string) =>
    history.push(urls.subscription.url({ productName: codeToName(basisSubscriptionProductCode) }));

  const subsClassName = classNames(
    'flex-grow-1 filled-basket__content__name filled-basket__content__name--underline',
    {
      'filled-basket__content__name--overview-step': isOverviewStep
    }
  );
  const goToFrontPage = () => {
    history.push(urls.simo.url());
  };

  return (
    <div className="filled-basket">
      <div className="filled-basket__header">{basketCms?.title}</div>
      <div className="filled-basket__content">
        <ul className="filled-basket__content__subscriptions">
          {recurring.map((recurringEntry: IPrice, index: number) => (
            <li className="filled-basket__content__subscription" key={`bakset-sub-${index}`}>
              <div className="d-flex ">
                {!isOverviewStep && (
                  <a
                    onClick={() =>
                      confirmDeleteModal(
                        recurringEntry.productId ?? '',
                        recurringEntry.subscriptionType as string
                      )
                    }
                  >
                    <CloseIcon className="filled-basket__content__icon" />
                  </a>
                )}
                <div
                  className={subsClassName}
                  onClick={() =>
                    !isOverviewStep &&
                    goToSubscription(recurringEntry.basisSubscriptionProductCode as string)
                  }
                >
                  {recurringEntry.name}
                </div>
                {recurringEntry.listPrice && (
                  <div className="filled-basket__content__list-price">
                    {addKr(recurringEntry.listPrice)}
                  </div>
                )}
                <div className="filled-basket__content__price">{addKr(recurringEntry.price)}</div>
              </div>

              <div className="filled-basket__content__sublines">
                {recurringEntry?.priceSublines?.map((subline) => (
                  <div data-hj-suppress>{subline}</div>
                ))}
                {!isOverviewStep && recurringEntry.configuration.isComplete && (
                  <span
                    className="filled-basket__content__edit"
                    onClick={() => editConfiguration()}
                  >
                    Rediger
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>
        <Modal
          isShown={isVisible}
          hide={confirmDeleteModal}
          modalContent={
            <ConfirmMainSubscriptionModal
              onDelete={() => removeSubscriptions && removeSubscriptions(productId as string)}
              subscriptionType={subscriptionType as string}
              /* @ts-ignore */
              onCancelDelete={onCancelDelete}
              basketCms={basketCms}
            />
          }
        />
        {/* Betal pr md */}
        <div className="d-flex filled-basket__content__recurring-total ">
          <div className="flex-grow-1 filled-basket__content__name filled-basket__content__name--bold">
            {recurringTotal?.name}
          </div>
          {recurringTotal?.listPrice && (
            <div className="filled-basket__content__list-price">
              {addKr(recurringTotal?.listPrice)}
            </div>
          )}
          <div className="filled-basket__content__name filled-basket__content__name--bold">
            {addKr(recurringTotal?.price)}
          </div>
        </div>

        {/* Oprettelse */}
        <div className="filled-basket__content__one-time-fees">
          {fees?.map((fee: IPrice) => (
            <div className="d-flex  ">
              <div className="flex-grow-1">{fee.name}</div>
              {fee.listPrice && (
                <div className="filled-basket__content__one-time-fees__list-price">
                  {addKr(fee.listPrice)}
                </div>
              )}
              <div>{addKr(fee.price)}</div>
            </div>
          ))}
        </div>
        {/* Engangsbeløb i alt */}
        <div className="d-flex filled-basket__content__recurring-total ">
          <div className="flex-grow-1 filled-basket__content__name filled-basket__content__name--bold">
            {feesTotal?.name}
          </div>
          {feesTotal?.listPrice && (
            <div className="filled-basket__content__one-time-fees__list-price">
              {addKr(feesTotal?.listPrice)}
            </div>
          )}
          <div className="filled-basket__content__name filled-basket__content__name--bold">
            {addKr(feesTotal?.price)}
          </div>
        </div>
        <div className="filled-basket__min-price">
          <a className="ys-link" onClick={toggle}>
            {linkToMinimumPriceCalculationText}
          </a>
        </div>
        <div className="filled-basket__minimum-bind">
          {documentToReactComponents(basketCms.minimumBindingText.json, bodyTextRenderOptions)}
        </div>
        <Modal
          isShown={isShown}
          hide={toggle}
          modalContent={
            <MinimumPriceModal
              subscription={minimumPriceCalculation}
              minimumPriceCalculationCms={basketCms.minimumPriceCalculation}
            />
          }
        />
      </div>
      {!isOverviewStep && (
        <div className="filled-basket__button-container">
          <div className="filled-basket__button-container__front">
            {productCode && !btlProducts.includes(productCode) && (
              <Button value={basketCms?.buttonFrontPage} isLink onClick={() => goToFrontPage()} />
            )}
          </div>
          <div className="filled-basket__button-container__continue">
            <button
              className="ys-button ys-button--cta ys-button--block"
              onClick={goToNemIDOrCheckout}
            >
              <span className="ys-button__text">{basketCms?.buttonContinue}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilledBasket;
